// removed by extract-text-webpack-plugin
module.exports = {"failure":"c-Failure__failure"};